import axios from "axios";
import { saveAs } from "file-saver";
import { PROYECT } from "services/api";
import { reportDiscountsRelationshipTypes } from "redux/reducers/Reports/reportDiscountsRelationship/types";
import { setSnackbar, startRequestComp, stopRequestComp } from "redux/actions/search/searchActions";
import { getErrorBlob } from "helpers/extractError";

const { SET_DISCOUNTS_RELATIONSHIP_FILTERS } = reportDiscountsRelationshipTypes;

export const getReportDiscountsRelationshipAction = ({ startDate, endDate, station, isPdf = true }) => {
  return async (dispatch, getState) => {
    const token = getState().login.token || localStorage.getItem('crm-user');
    dispatch(startRequestComp('loadingDiscountsRelationship'));
    try {
      const url = `${process.env.REACT_APP_URL}${PROYECT}/reports/discounts-relationship?idStation=${station.id}&start=${startDate}&end=${endDate}&pdf=${isPdf}`;
      const res = await axios.get(url, {
        headers: { authorization: token },
        responseType: "blob"
      });

      saveAs(res.data, `Reporte_Relación_Descuento_${startDate}_${endDate}.${isPdf ? "pdf" : "xlsx"}`);
      dispatch(setSnackbar("Reporte descargado con éxito", "success"));
    } catch (err) {
      dispatch(setSnackbar(await getErrorBlob(err)));
    } finally {
      dispatch(stopRequestComp('loadingDiscountsRelationship'));
    }
  };
};

export const setReportDiscountsRelationshipFilters = (key = "", value) => ({
  type: SET_DISCOUNTS_RELATIONSHIP_FILTERS,
  payload: { key, value }
});
